module.exports = __webpack_public_path__ + "assets/already_expired.21f8cead.svg";